import { type TFunction } from 'i18next';

const root = 'taxreturn-report';

export const title = (t: TFunction, key: string) => t(`${root}.title.${key}`);

export const label = (t: TFunction, key: string) => t(`${root}.label.${key}`);

export const headers = (t: TFunction, key: string) => t(`${root}.header.${key}`);

export const buttons = (t: TFunction, key: string) => t(`${root}.button.${key}`);

export const validations = (t: TFunction, key: string) => t(`${root}.validations.${key}`);

export const messages = (t: TFunction, key: string) => t(`${root}.messages.${key}`);
